const nullToEmptyStringOrDefault = (value) => (value ? value : '');

const getQueryString = (locationSearch, queryString) => {
    const params = new URLSearchParams(locationSearch);
    return params.get(queryString);
};
const openInNewTab = (url) => {
    const newWindow = window.open(url, '_blank');
    // const newWindow = window.open(url, '_blank', 'noopener,noreferrer');
    // if (newWindow) newWindow.opener = null;
    // const newWindow = window.open(url);
    return newWindow;
};
const assignWindowLocation = (url) => {
    window.location.assign(url);
};

const readCookie = (name) => {
    const nameEQ = name + '=';
    const ca = document.cookie.split(';');
    for (let i = 0; i < ca.length; i++) {
        let c = ca[i];
        while (c.charAt(0) == ' ') c = c.substring(1, c.length);
        if (c.indexOf(nameEQ) == 0) return c.substring(nameEQ.length, c.length);
    }
    return null;
};

const deleteCookie = (name, domain /*, path*/) => {
    document.cookie = `${name}=;domain=${domain ? domain : ''};path=/;max-age=0`;
    if (readCookie(name)) {
        // document.cookie =
        //     name +
        //     '=' +
        //     (path ? ';path=' + path : '') +
        //     (domain ? ';domain=' + domain : '') +
        //     ';expires=Thu, 01 Jan 1970 00:00:01 GMT';
    }
};

export { nullToEmptyStringOrDefault, getQueryString, openInNewTab, assignWindowLocation, readCookie, deleteCookie };

export const upperCaseThis = (str) => str.toUpperCase();
export const capitalizeFstLetterOfThis = (str) => str.charAt(0).toUpperCase() + str.slice(1);

export const getSDWT = (key, value) => {
    const t = localStorage.getItem(key);
    return t && t === value;
};

export const toReactSelectObject = (obj, displayName, valueName) => {
    return obj
        ? {
              label: obj[displayName],
              value: obj[valueName],
          }
        : null;
};
